module.exports = __webpack_public_path__ + "static/media/homeCheck.68e31767.svg";